// Favoriting is per-user and private; pinning is org-wide. Users could not tell
// the two apart, so every surface that offers either action states its scope —
// and states it the same way. These are the canonical phrasings: import them
// rather than retyping, so a wording change lands everywhere at once.
//
// Both casings are written out rather than derived with `.toLowerCase()`, which
// would mangle the first proper noun anyone puts in this copy.

/** Sentence-initial, e.g. "Only visible to you." */
export const PRIVATE_SCOPE = "Only visible to you";

/** Mid-sentence, e.g. "Add to favorites (only visible to you)". */
export const PRIVATE_SCOPE_PARENTHETICAL = "(only visible to you)";

/** Mid-sentence, e.g. "Show in pinned KPI views for everyone in the organization". */
export const ORG_SCOPE = "for everyone in the organization";

/** Describes a stored state rather than an action, e.g. "Metrics pinned for the organization". */
export const ORG_SCOPE_POSSESSIVE = "for the organization";
